import React from 'react';
import { Alert, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * What every managed lead mutation failure has to decide before it can be
 * shown. The describing functions own the wording and these flags; this
 * component owns nothing but their rendering.
 */
export interface ManagedLeadFailureAlertProps {
  message: string;
  severity: 'error' | 'warning';
  /** The session, not the mutation, failed: the only way out is the login. */
  sessionExpired: boolean;
  /** Sending the same thing again can still succeed. */
  retryable: boolean;
  onRetry: () => void;
}

/**
 * One failure, one alert: an expired session offers the login and nothing else,
 * a retryable failure offers Riprova, and everything else is a statement the
 * operator can only read and act on elsewhere.
 */
const ManagedLeadFailureAlert = ({
  message,
  severity,
  sessionExpired,
  retryable,
  onRetry,
}: ManagedLeadFailureAlertProps) => (
  <Alert
    severity={sessionExpired ? 'warning' : severity}
    action={
      sessionExpired ? (
        <Button color="inherit" component={RouterLink} to="/login">
          Vai al login
        </Button>
      ) : retryable ? (
        <Button color="inherit" onClick={onRetry}>
          Riprova
        </Button>
      ) : undefined
    }
  >
    {message}
  </Alert>
);

export default ManagedLeadFailureAlert;
